import React, { useState, useEffect } from "react";
import { Link, Navigate, useParams } from 'react-router-dom'
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTachometer, faTasks, faEye, faPencil, faTrashCan, faVideo, faArrowLeft, faDumbbell, faCheckCircle, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select';
import { useRecoilState } from 'recoil';
import ReactPlayer from 'react-player/lazy'

import { topAlertMessageState, topAlertStatusState } from "../../../../AppState";
import { getSessionTemplateDetailAPI, putSessionTemplateUpdateAPI } from "../../../../API/SessionTemplate";
import { getSelectedOptions } from "../../../../Helpers/selectHelper";
import useLocalStorage from "../../../../Hooks/useLocalStorage";
import DataDisplayRowText from "../../../Reusable/DataDisplayRowText";
import PageLoadingContent from "../../../Reusable/PageLoadingContent";


function SessionTemplateVideoSectionDetail() {
    ////
    //// URL parameters.
    ////

    const { id, vsIndex, eIndex } = useParams();

    ////
    //// Global state.
    ////

    const [topAlertMessage, setTopAlertMessage] = useRecoilState(topAlertMessageState);
    const [topAlertStatus, setTopAlertStatus] = useRecoilState(topAlertStatusState);

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [sessionTemplate, setSessionTemplate] = useLocalStorage(id, "");
    const [showDeletionConfirmationModal, setShowDeletionConfirmationModal] = useState(false);
    const [forceURL, setForceURL] = useState("");
    const [isFetching, setFetching] = useState(false);

    ////
    //// API.
    ////

    // --- Detail --- //

    function onSessionTemplateDetailSuccess(response){
        console.log("onSessionTemplateDetailSuccess: Starting...");
        setSessionTemplate(response);
    }

    function onSessionTemplateDetailError(apiErr) {
        console.log("onSessionTemplateDetailError: Starting...");
        setErrors(apiErr);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionTemplateDetailDone() {
        console.log("onSessionTemplateDetailDone: Starting...");
        setFetching(false);
    }

    // --- Delete --- //

    function onSessionTemplateUpdateSuccess(response){
        console.log("onSessionTemplateUpdateSuccess: Starting..."); // For debugging purposes only.

        // Update notification.
        setTopAlertStatus("success");
        setTopAlertMessage("Session template deleted");
        setTimeout(() => {
            console.log("onDeleteConfirmButtonClick: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // Upone success redirect user back to the `/users` list page.
        setForceURL("/session-template/" + id + "/video-section/" + vsIndex + "/exercises");
    }

    function onSessionTemplateUpdateError(apiErr) {
        console.log("onSessionTemplateUpdateError: Starting..."); // For debugging purposes only.
        setErrors(apiErr);

        // Update notification.
        setTopAlertStatus("danger");
        setTopAlertMessage("Failed deleting");
        setTimeout(() => {
            console.log("onSessionTemplateUpdateError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionTemplateUpdateDone() {
        console.log("onSessionTemplateUpdateDone: Starting...");
        setFetching(false);
    }

    ////
    //// Event handling.
    ////

    const onDeleteConfirmButtonClick = () => {
        console.log("onDeleteConfirmButtonClick"); // For debugging purposes only.

        const videoSection = sessionTemplate.videoSections[vsIndex];
        const { exercises } = videoSection;
        console.log(exercises);
        const selectedExerciseForDeletion = exercises[eIndex];

        console.log("selectedExerciseForDeletion:", selectedExerciseForDeletion);

        //
        // The following code will remove the data from the JSON.
        //

        let eIndex2;
        for (let exerciseIndex in videoSection.exercises) {
            let ex = videoSection.exercises[exerciseIndex];
            if (ex.name === selectedExerciseForDeletion.name) {
                console.log(ex);
                eIndex2 = exerciseIndex;
                break;
            }
        }

        console.log("videoSectionIndex:", eIndex2);
        videoSection.exercises.splice(eIndex2, 1);

        // Update the session.
        console.log("onSubmitClick, sessionTemplate:", sessionTemplate);

        putSessionTemplateUpdateAPI(
            sessionTemplate,
            onSessionTemplateUpdateSuccess,
            onSessionTemplateUpdateError,
            onSessionTemplateUpdateDone
        );
        setShowDeletionConfirmationModal(false);
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.
            setFetching(true);
            getSessionTemplateDetailAPI(
                id,
                onSessionTemplateDetailSuccess,
                onSessionTemplateDetailError,
                onSessionTemplateDetailDone
            );
        }

        return () => { mounted = false; }
    }, [id]);

    ////
    //// Component rendering.
    ////

    const videoSection = sessionTemplate.videoSections[vsIndex];
    const { exercises } = videoSection;
    console.log(exercises);
    const exercise = exercises[eIndex];

    // SPECIAL THANKS TO: https://stackoverflow.com/a/9851769
    // Safari 3.0+ "[object HTMLReusableConstructor]"
    let isSafari = /constructor/i.test(window.HTMLReusable) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

    if (forceURL !== "") {
        return <Navigate to={forceURL}  />
    }

    return (
        <>
            <div class="container">
                <section class="section">
                    {/* Desktop Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard"><FontAwesomeIcon className="fas" icon={faTachometer} />&nbsp;Dashboard</Link></li>
                            <li class=""><Link to="/session-templates" aria-current="page"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session Templates</Link></li>
                            <li class=""><Link to={`/session-template/${id}/video-sections`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Details (Video Sections)</Link></li>
                            <li class=""><Link to={`/session-template/${id}/video-section/${vsIndex}/exercises`} aria-current="page"><FontAwesomeIcon className="fas" icon={faVideo} />&nbsp;Video Section (Exercises)</Link></li>
                            <li class="is-active"><Link aria-current="page"><FontAwesomeIcon className="fas" icon={faDumbbell} />&nbsp;Exercise</Link></li>
                        </ul>
                    </nav>

                    {/* Mobile Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
                        <ul>
                            <li class=""><Link to={`/session-template/${id}/video-section/${vsIndex}/exercises`} aria-current="page"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Video Section (Exercises)</Link></li>
                        </ul>
                    </nav>

                    {/* Modals */}
                    <nav class="">
                        <div class={`modal ${showDeletionConfirmationModal ? 'is-active' : ''}`}>
                            <div class="modal-background"></div>
                            <div class="modal-card">
                                <header class="modal-card-head">
                                    <p class="modal-card-title">Are you sure?</p>
                                    <button class="delete" aria-label="close" onClick={(e, ses) => setShowDeletionConfirmationModal(false)}></button>
                                </header>
                                <section class="modal-card-body">
                                    You are about to delete this exercise and all the data inside of it. This action is cannot be undone. Are you sure you would like to continue?
                                </section>
                                <footer class="modal-card-foot">
                                    <button class="button is-success" onClick={onDeleteConfirmButtonClick}>Confirm</button>
                                    <button class="button" onClick={(e, ses) => setShowDeletionConfirmationModal(false)}>Cancel</button>
                                </footer>
                            </div>
                        </div>
                    </nav>

                    {/* Page */}
                    <nav class="box">

                        {/* Title + Options */}
                        <div class="columns">
                            <div class="column">
                                <p class="title is-4"><FontAwesomeIcon className="fas" icon={faDumbbell} />&nbsp;Exercise</p>
                                <p class="subtitle is-6"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Details</p>
                            </div>
                            <div class="column has-text-right">
                                <Link to={`/session-template/${id}/video-section/${vsIndex}/exercise/${eIndex}/edit`} class="button is-small is-warning is-fullwidth-mobile" type="button">
                                    <FontAwesomeIcon className="mdi" icon={faPencil} />&nbsp;Edit Exercise
                                </Link>
                                &nbsp;
                                <button onClick={(e, ses) => setShowDeletionConfirmationModal(true)} class="button is-small is-danger is-fullwidth-mobile" type="button">
                                    <FontAwesomeIcon className="mdi" icon={faTrashCan} />&nbsp;Delete Exercise
                                </button>
                            </div>
                        </div>

                        {!isSafari &&
                            <article class="message is-warning pt-0">
                              <div class="message-body">
                                Your web browser may not support the <i>m3u8 file format</i> so you'll need to download an accompanying plugin to view the video content. Here is the recommended plugin for Chrome Web browser:
                                <br/><br/>
                                - <b><a href="https://chrome.google.com/webstore/detail/native-hls-playback/emnphkkblegpebimobpbekeedfgemhof">Native HLS Playback&nbsp;<FontAwesomeIcon className="fas" icon={faArrowUpRightFromSquare} /></a></b>
                              </div>
                            </article>
                        }

                        {isFetching
                            ?
                            <PageLoadingContent displayMessage={"Please wait"} />
                            :
                            <>
                                {exercise !== undefined && exercise !== null && exercise !== "" && <div class="container">
                                    <DataDisplayRowText
                                        label="Name"
                                        value={exercise.name}
                                    />

                                    <DataDisplayRowText
                                        label="Type"
                                        value={exercise.type}
                                    />

                                    <DataDisplayRowText
                                        label="Duration"
                                        value={exercise.duration}
                                    />

                                    <div class="field pb-4">
                                        <label class="label">Preview Image</label>
                                        <div class="control">
                                            {exercise.previewImageUrl
                                                ? <>
                                                    <div className="has-background-black box has-text-white has-text-centered is-size-3" style={{borderRadius: "20px"}}>
                                                        <img src={exercise.previewImageUrl} alt="Preview Image URL" />
                                                    </div>
                                                </>
                                                : <>
                                                    <p>-</p>
                                                </>
                                            }
                                        </div>
                                    </div>

                                    <div class="field">
                                        <label class="label">Preview (Deprecated)</label>
                                        <div class="control">
                                            {exercise.previewUrl
                                                ? <>
                                                    {!isSafari
                                                    ? <>
                                                        <div className="has-background-black box has-text-white has-text-centered is-size-3" style={{borderRadius: "20px"}}>
                                                            <br />
                                                            View video by <b><a href={exercise.previewUrl} target="_blank" rel="noreferrer">clicking here&nbsp;<FontAwesomeIcon className="fas" icon={faArrowUpRightFromSquare} /></a></b> to open in new tab. <br />
                                                            <br />
                                                        </div>
                                                    </>
                                                    : <>
                                                        <div className="p-3 has-background-black box" style={{borderRadius: "20px"}}>
                                                            <video width="100%" height="100%" controls>
                                                                 <source src={exercise.previewUrl} type="application/x-mpegURL" />
                                                            </video>
                                                        </div>
                                                    </>
                                                    }
                                                </>
                                                : <p>Not ready</p>
                                            }
                                        </div>
                                        <br />
                                    </div>

                                    <DataDisplayRowText
                                        label="Preview Description"
                                        value={exercise.previewDescription}
                                    />

                                    <div class="field pb-4">
                                        <label class="label">Video</label>
                                        <div class="control">
                                            {exercise.videoUrl
                                                ? <>
                                                    {!isSafari
                                                    ? <>
                                                        <div className="has-background-black box has-text-white has-text-centered is-size-3" style={{borderRadius: "20px"}}>
                                                            <br />
                                                            View video by <b><a href={exercise.videoUrl} target="_blank" rel="noreferrer">clicking here&nbsp;<FontAwesomeIcon className="fas" icon={faArrowUpRightFromSquare} /></a></b> to open in new tab. <br />
                                                            <br />
                                                        </div>
                                                    </>
                                                    : <>
                                                        <div className="p-3 has-background-black box" style={{borderRadius: "20px"}}>
                                                            <video width="100%" height="100%" controls>
                                                                 <source src={exercise.videoUrl} type="application/x-mpegURL" />
                                                            </video>
                                                        </div>
                                                    </>
                                                    }
                                                </>
                                                : <p>Not ready</p>
                                            }
                                        </div>
                                        <br />

                                    </div>

                                    <div class="columns">
                                        <div class="column is-half">
                                            <Link to={`/session-template/${id}/video-section/${vsIndex}/exercises`} class="button is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Exercises</Link>
                                        </div>
                                        <div class="column is-half has-text-right">
                                            <Link to={`/session-template/${id}/video-section/${vsIndex}/exercise/${eIndex}/edit`} class="button is-warning is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faCheckCircle} />&nbsp;Edit</Link>
                                        </div>
                                    </div>

                                </div>}
                            </>
                        }
                    </nav>
                </section>
            </div>
        </>
    );
}

export default SessionTemplateVideoSectionDetail;
